import {Dispatch, PropsWithChildren, useReducer} from "react";
import {
  TPayoutSettingsActions,
  initialPayoutSettingsState,
  payoutSettingsReducer,
} from "../reducer";
import {createContext} from "../../../../../../context/create-context";

type TPayoutSettingsContextState = {
  state: typeof initialPayoutSettingsState;
  dispatch: Dispatch<TPayoutSettingsActions>;
};

const [useContext, ContextProvider] = createContext<TPayoutSettingsContextState>();

export const usePayoutSettingsContext = useContext;

export const PayoutSettingsProvider = ({children}: PropsWithChildren) => {
  const [state, dispatch] = useReducer(payoutSettingsReducer, initialPayoutSettingsState);

  return <ContextProvider value={{state, dispatch}}>{children}</ContextProvider>;
};
